// 产品介绍
<template>
  <div class="cpjs width1200">
    <div class="item-desc">
      <p class="text1">资源组成</p>
      <p class="text2">IP资源来源于全国各地的真实家宽用户。</p>
    </div>
    <!--<div class="cpjs-desc">
      <p>
        IP资源来源于全国各地的真实家宽用户
      </p>
      <p>
        传统IP代理池：在地区所在机房接入对应数量的拨号线路，在软路由上多拨。一台边点设备对应多条同地区的拨号线路。通常这种拨号线路多为运营商单独划分的代理线路。这些代理线路对应的IP池污染程度极高，经常会被反爬程度高的目标站点风控
      </p>
      <p>
        家庭住宅IP代理池：单一的出口IP对应一台设备（路由器、机顶盒、pad等），用户利用家庭空闲带宽跑边缘计算收取佣金。对应的是运营商的家用IP池，IP为真人家用IP
      </p>
    </div>-->
    <!--<img
      :src="require('@/assets/images/cpjs1.png')"
      alt=""
      class="cpjs-imgs w-100"
    />-->
    <div class="cpjs-list">
      <p class="title">多贝云超级HTTP隧道产品特性</p>
      <div class="cpjs-list-content d-flex d-flex-jc-sb d-flex-fw-w">
        <div class="item" v-for="(item, index) in cpjsList" :key="index">
          <img :src="item.icon" alt="" class="img1" />
          <img :src="item.icon_active" alt="" class="img2" />
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cpjsList: [
        {
          icon: require("@/assets/images/cpjs2.png"),
          icon_active: require("@/assets/images/cpjs8.png"),
          desc: "无需API提取，舍去繁琐的api操作",
        },
        {
          icon: require("@/assets/images/cpjs3.png"),
          icon_active: require("@/assets/images/cpjs9.png"),
          desc: "代理IP可用时长灵活控制，分为每请求随机、1-30分钟指定，指定时长到期自动过期",
        },
        {
          icon: require("@/assets/images/cpjs4.png"),
          icon_active: require("@/assets/images/cpjs10.png"),
          desc: "通道数、并发数、带宽均可按需配置",
        },
        {
          icon: require("@/assets/images/cpjs5.png"),
          icon_active: require("@/assets/images/cpjs11.png"),
          desc: "IP资源池500w",
        },
        {
          icon: require("@/assets/images/cpjs6.png"),
          icon_active: require("@/assets/images/cpjs12.png"),
          desc: "支持去重，多种去重方式",
        },
        {
          icon: require("@/assets/images/cpjs7.png"),
          icon_active: require("@/assets/images/cpjs13.png"),
          desc: "支持指定地区，三百多城市可选",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.cpjs {
  padding: 50px 0 116px;

  .item-desc {
    margin-bottom: 30px;
    p {
      color: #000;
      &.text1 {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 6px;
      }
      &.text2 {
        font-size: 18px;
      }
    }
    ul {
      margin-left: 20px;
      li {
        list-style: disc;
        &::marker {
          color: #27a7e7;
          font-size: 24px;
        }
      }
    }
    dl {
      margin-top: 20px;
      dd {
        margin-right: 76px;
        img {
          margin-right: 10px;
        }
      }
    }
  }

  .cpjs-desc {
    p {
      font-size: 18px;
      color: #000;
    }
  }
  .cpjs-imgs {
    margin-top: 75px;
  }
  .cpjs-list {
    margin-top: 74px;
    .title {
      font-size: 24px;
      color: #000;
      font-weight: bold;
      text-align: center;
    }
    .cpjs-list-content {
      .item {
        margin-top: 64px;
        width: 33.3%;
        text-align: center;
        img {
          &.img2 {
            display: none;
          }
        }
        p {
          width: 74%;
          margin: 24px auto 0;
          font-size: 18px;
          color: #474747;
          text-align: center;
        }
        &:hover {
          img {
            &.img1 {
              display: none;
            }
            &.img2 {
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .cpjs {
    padding: 4% 0;
  }
  .cpjs .cpjs-list .title {
    font-size: 16px;
  }
  .cpjs .cpjs-desc {
    margin-bottom: 2%;
  }
  .cpjs .cpjs-list .cpjs-list-content .item img {
    width: 50px;
  }
  .cpjs .cpjs-desc p,
  .cpjs .cpjs-list .cpjs-list-content .item p {
    font-size: 14px;
  }
  .cpjs .cpjs-list .cpjs-list-content .item p {
    margin: 2% auto;
  }
  .cpjs .cpjs-imgs,
  .cpjs .cpjs-list {
    margin-top: 2%;
  }
  .cpjs .cpjs-list .cpjs-list-content .item {
    width: 49%;
    margin-top: 2%;
  }

  .cpjs .item-desc {
    margin-bottom: 2%;
  }
  .cpjs .item-desc p.text1,
  .cpjs .item-desc ul li::marker {
    font-size: 16px;
  }
  .cpjs .item-desc p.text2,
  .cpjs .item-desc ul li {
    font-size: 14px;
  }
  .cpjs .item-desc dl {
    flex-wrap: wrap;
  }
  .cpjs .item-desc dl dd {
    font-size: 14px;
    margin-right: 0;
    width: 50%;
  }

}
@media (max-width: 475px) {
  .cpjs .cpjs-list .cpjs-list-content .item {
    width: 100%;
  }
}
</style>
